<div id="top" ></div>
<app-navbar></app-navbar>
<br>
<div style="background-color:#f5f5f5;width:99%" class="mx-auto d-block">
  <div class="container-fluid" style="width:99%" >
    <div class="row" >
       <div class="col-md-4">
     <br>
      <p-panel   [style]="{'margin-bottom':'20px'}">

        <p-header>
          <div class="ui-helper-clearfix">
           <h2>   <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">My Profile </span> </h2>     
            </div>
         </p-header>
                 <div class="container-fluid">
                 <div class="row" >
                 <div class="col-md-6">
                           <label  class="text-break aetna-table-header">First Name  :<br/> {{firstName}} </label>
                            <hr>
                           </div>
               <div class="col-md-6">
                <label  class="text-break aetna-table-header">Last Name :<br/> {{lastName}}</label>
                    <hr>
            </div>
            <div class="col-md-12">
                <label  style="word-break: break-all" class="text-break aetna-table-header">Email ID :<br/> {{emailId}} </label>
                    <hr>
                </div>
              </div>
            </div >
      </p-panel>
      <br>
      <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true" *ngIf="payerDisplay_qu || devDisplay_qu || brokerDisplay_qu || providerDisplay_qu">
        <div class="toast-header">
        
          <strong class="mr-auto">Notification</strong>
         
          
        </div>
        <div class="toast-body" >
       
          <div *ngIf="payerDisplay_qu">
              <i class="pi pi-minus-circle" style="font-size: 1em;color: #7d3f98;"></i>
              &nbsp; 
             {{payerMsg_qu}}

              <a class="aetnaMainDiv"   routerLink="/payer/questionnaire"> <u>Please click here to submit</u></a>.
              <br>
              <br>
            </div>
            <div *ngIf="devDisplay_qu">
               <i class="pi pi-minus-circle" style="font-size: 1em;color: #7d3f98;"></i>
                &nbsp; 
               {{devMsg_qu}}

                <a class="aetnaMainDiv"   routerLink="/third-party-developer/questionnaire"> <u>Please click here to submit</u></a>.
                <br>
                <br>
              </div>

            <div *ngIf="brokerDisplay_qu">
              <i class="pi pi-minus-circle" style="font-size: 1em;color: #7d3f98;"></i>
               &nbsp; 
              {{brokerMsg_qu}}

               <a class="aetnaMainDiv"   routerLink="/broker/questionnaire"> <u>Please click here to submit</u></a>.
               
              </div>

              <div *ngIf="providerDisplay_qu">
                <i class="pi pi-minus-circle" style="font-size: 1em;color: #7d3f98;"></i>
                 &nbsp; 
                {{providerMsg_qu}}
  
                 <a class="aetnaMainDiv"   routerLink="/provider/questionnaire"> <u>Please click here to submit</u></a>.
                 
                </div>

        </div>
      </div> 
       </div>
       <div class="col-md-8">
       <br/>
       <p-panel   >
        <p-header>
          <div class="ui-helper-clearfix">
             <h2> <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">My Approvals</span> </h2>     
            </div>
      </p-header>

        <div class="container-fluid" style="width:99%" >
          <div class="row" >
            <div class="col-md-5"></div>
            <div class="col-md-2">
                <p-progressSpinner *ngIf="showSpiner" [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            </div>
            <div class="col-md-5"></div>
          </div> 
        </div>

        <p-table [value]="approvalsVos" *ngIf="!showSpiner" [style]="{width: '100%'}" [responsive]="true"  [rows]="5" [paginator]="false">
          <ng-template pTemplate="header">
                <tr>
                      <th style="width: 30%;">Environment</th>
                       <th style="width: 20%" >Role</th>
                       <th style="width: 20%;">Approval Status</th>
                       <th style="width: 30%;">Create Application</th>
                    
                
                </tr>
          </ng-template>
          <ng-template pTemplate="body" let-sub>
                <tr *ngIf="sub.approvalStatus=='P' || sub.approvalStatus=='A' || sub.approvalStatus=='R'">
                       <td class="font-weight-bold" class="text-break" >{{sub.environment | titlecase}}</td>
                       <td class="font-weight-bold" class="text-break">{{sub.roleText}}</td>
                        <td ><span [class]="'customer-badge status-' + sub.cssname">{{sub.statusText}}</span></td>
                      <td>
                      
                        <button *ngIf="sub.approvalStatus=='A'" type="button" pButton  (click)="moveToAppCreation(sub)" label="Create Application"class="aetna-button ui-button-raised ui-button-rounded" ></button>
 
                      </td>
                 </tr>
          </ng-template>
        </p-table>


      <div [hidden]="showNoSubData">
        <p class="aetna-table-header">No Subscription Data Available.</p>
      </div>
   <!-- 
      <div class="example-container mat-elevation-z8" [hidden]="showGrid" >
      
  
          <table mat-table  [dataSource]="dataSource" style="background-color: white;"  >

          
            <ng-container matColumnDef="appName" sticky>
              <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header">Application Name</th>
              <td mat-cell style="width:35%;padding-right:12px ;" *matCellDef="let row"  class="text-break aetna-table-row" > {{row.appName}} 
               
             
                <span *ngIf="row.environment=='production'" class="badge badge-pill badge-primary">{{row.environment}}</span>
               
                <span *ngIf="row.environment=='sandbox'" class="badge badge-pill badge-secondary">{{row.environment}}</span>
              
                
              </td>
            </ng-container>
          
          
            <ng-container matColumnDef="productName">
              <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header"> Product Name </th>
              <td mat-cell style="width:35%;padding-right:12px ;" class="text-break aetna-table-row" *matCellDef="let row"> {{row.productName}}({{row.productVersion}}) </td>
            </ng-container>
            
            <ng-container matColumnDef="nonProdStatus">
              <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header">Status </th>
              <td mat-cell style="width:15%;padding-right:12px ;" class="aetna-table-row" *matCellDef="let row"> 
                <span [class]="'customer-badge status-' + row.cssname">{{row.nonProdStatus}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="apis">
              <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header"> APIs </th>
              <td mat-cell style="width:15%;padding-right:12px ;" class="aetna-table-row" *matCellDef="let row"> <button pButton  (click)="viewApisForSubscription(row)"  label="View"   class="aetna-button ui-button-raised ui-button-rounded" > </button> </td>
            </ng-container>
          
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


          </table>
          <mat-paginator aria-label="paginator" role="region"  #pagMain class="aetna-table-header" [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
        </div >
      -->
       </p-panel>
       </div>
       <div class="col-md-4">

         

       </div>
       <div class="col-md-8">
         <br>
        <p-panel *ngIf="apisViewEnable">
          <p-header>
            <div class="ui-helper-clearfix">
             <h2>   <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">{{selectedSub.productName}} </span>      </h2>
              </div>
        </p-header>

<!--
        <div  class="example-container mat-elevation-z8">
          
 
          <table mat-table  [dataSource]="dataSourceAPIs" style="background-color: white;"  >
  
          
            <ng-container matColumnDef="apis">
              <th mat-header-cell *matHeaderCellDef class="aetna-table-header">APIs</th>
              <td mat-cell style="width:25%" *matCellDef="let row"  class="text-break"  style="font-family: Open Sans,Helvetica Neue,sans-serif;
              font-size: 14px;">   {{row['path']}}
              </td>
            </ng-container>
          
          
          
            <tr mat-header-row *matHeaderRowDef="displayedColumnsAPIs"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsAPIs;"></tr>
  
  
          </table>
         
        </div >
    -->     
    

          <p-table #dt  *ngIf="apisViewEnable" [columns]="apisPlanCols" [value]="apisView" [style]="{width: '100%'}"  [responsive]="true" [scrollable]="true" scrollHeight="280px" [rows]="5">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th>
                      <label for="api"> APIs</label>
                      <br>
                      <input  id="api"  pInputText type="text"
                               (input)="dt.filter($event.target.value, 'path', 'contains')" placeholder="Search"/>
                     
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr *ngIf="!(rowData.path=='fhir-server-pkce-api-provider' || rowData.path=='fhir-mobile-pkce-api-provider')  ">
                  <td class="text-break">
                    {{rowData['path']}}
                </td>
                </tr>
            </ng-template>
          </p-table>
         
          </p-panel>
       </div>
  </div>
 </div>
</div>